module.exports = __webpack_public_path__ + "img/message.6a2ab36b.svg";